import _ from 'lodash'

import { useMemo } from 'modules/core/hooks/useMemo'

interface Separator {
  key: string
  content: string
}

function getOffsetPages(
  totalPages: number,
  currentPage: number,
  maxPages: number,
  goToPage: (page: number) => void
) {
  let pages: (number | Separator)[] = [...Array(totalPages).keys()].map((page) => page + 1)
  if (totalPages > maxPages) {
    const newPages = [...pages]
      .sort((a, b) => Math.abs((a as number) - currentPage) - Math.abs((b as number) - currentPage))
      .slice(0, maxPages - 2)
      .sort((a, b) => (a as number) - (b as number))

    if (newPages[0] !== 1) {
      newPages[0] === 2
        ? newPages.unshift(1)
        : newPages.unshift(1, { key: 'firstSeparator', content: '...' })
    }

    if (newPages[newPages.length - 1] !== totalPages) {
      newPages[newPages.length - 1] === totalPages - 1
        ? newPages.push(totalPages)
        : newPages.push({ key: 'secondSeparator', content: '...' }, totalPages)
    }

    if (newPages.length === maxPages + 1) {
      if (typeof newPages[1] === 'number') {
        newPages.splice(-3, 1)
      } else {
        newPages.splice(2, 1)
      }
    }

    if (newPages.length === maxPages + 2) {
      newPages.splice(2, 1)
      newPages.splice(-3, 1)
    }

    pages = newPages
  }

  return pages.map((page) => ({
    key: String(typeof page === 'number' ? _.uniqueId() : page.key),
    content: String(typeof page === 'number' ? page : page.content),
    onClick: typeof page === 'number' ? () => goToPage(page) : undefined,
    highlighted: typeof page === 'number' && page === currentPage,
  }))
}

export default function useOffsetPages(
  totalPages: number,
  currentPage: number,
  maxPages: number,
  goToPage: (page: number) => void
) {
  return useMemo(
    () => getOffsetPages(totalPages, currentPage, maxPages, goToPage),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [totalPages, currentPage, maxPages]
  )
}
